import React from "react";
// NAVIGATION
import { useLocation } from "react-router-dom";
import useLeaveStandaloneEditor from "../../../customHooks/useLeaveStandaloneEditor";
// WIZARD
import { WizardProvider } from "../../setupWizard/WizardContext";
import StepServer from "../../setupWizard/steps/StepServer";

function ServersEdit() {
  const leave = useLeaveStandaloneEditor("/edge-management/servers");
  const location = useLocation();
  const idServer = new URLSearchParams(location.search).get("idServer");

  return (
    <WizardProvider>
      <StepServer
        editServerId={idServer || undefined}
        standalone
        onSaveSuccess={leave}
        onCancel={leave}
      />
    </WizardProvider>
  );
}

export default ServersEdit;
